import React, { useEffect, useState } from "react";
import {
    collection,
    getDocs,
    deleteDoc,
    doc
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import { db } from "../../firebase/firebase";
import "../../assets/css/admin/galleryCategories.css";

import Sidebar from "../Sidebar";
import Footer from "../../components/common/Footer";
import AdminNavbar from "../AdminNavbar";


function AdminGalleryCategories() {

    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deletePopup, setDeletePopup] = useState({
    show: false,
    id: null
});

const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    useEffect(() => {
        loadCategories();
    }, []);

    // ===========================
    // Load Categories
    // ===========================

    const loadCategories = async () => {

        try {

            setLoading(true);

            const snapshot = await getDocs(
                collection(db, "gallery_categories")
            );

            const data = [];

            snapshot.forEach((item) => {

                const category = item.data();

                data.push({
                    id: item.id,
                    name: category.title,
                    image: category.coverImage,
                    createdAt: category.createdAt
                });

            });

            setCategories(data);

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }

    };

    // ===========================
    // Delete Category
    // ===========================

    const deleteCategory = async (id) => {

    try {

        await deleteDoc(
            doc(db, "gallery_categories", id)
        );

        setPopup({
            show: true,
            type: "success",
            message: "Category Deleted Successfully"
        });

        loadCategories();

        setDeletePopup({
            show: false,
            id: null
        });

        setTimeout(() => {

            setPopup({
                show: false,
                type: "",
                message: ""
            });

        }, 3000);

    } catch (error) {

        console.log(error);

        setPopup({
            show: true,
            type: "error",
            message: "Failed To Delete Category"
        });

    }

};

    // ===========================
    // Loading
    // ===========================

    if (loading) {

        return (

            <div className="gallery-category-page">
                       
                <div className="loading">

                    Loading Categories...

                </div>

            </div>

        );

    }

    // ===========================
    // JSX
    // ===========================

    

        return (
           
            <>
{/* Success / Error Popup */}

{popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}

{/* Delete Confirmation */}

{deletePopup.show && (

    <div className="delete-overlay">

        <div className="delete-modal">

            <h2>

                Delete Category?

            </h2>

            <p>

                This action cannot be undone.

            </p>

            <div className="delete-actions">

                <button
                    className="cancel-btn"
                    onClick={() =>
                        setDeletePopup({
                            show: false,
                            id: null
                        })
                    }
                >
                    Cancel
                </button>

                <button
                    className="confirm-btn"
                    onClick={() =>
                        deleteCategory(deletePopup.id)
                    }
                >
                    Delete
                </button>

            </div>

        </div>

    </div>

)}


    <div className="admin-layout">
                <AdminNavbar/>
         <div className="admin-main">

             <Sidebar />

         

        <div className="gallery-category-page">

            <div className="category-header">

                <div>

                    <h1>Gallery Categories</h1>

                    <p>
                        Manage your photography gallery categories
                    </p>

                </div>

                <button
                    className="add-category-btn"
                    onClick={() =>
                        navigate("/admin/add-gallery-category")
                    }
                >
                    + Add Category
                </button>

            </div>

            {categories.length === 0 ? (

                <div className="empty-box">

                    <h2>No Categories Found</h2>

                    <button
                        onClick={() =>
                            navigate("/admin/add-gallery-category")
                        }
                    >
                        Add First Category
                    </button>

                </div>

            ) : (

                <div className="category-grid">

                    {categories.map((cat) => (

                        <div
                            className="admin-category-card"
                            key={cat.id}
                        >

                            <img
                                src={
                                    cat.image ||
                                    "https://via.placeholder.com/600x400?text=No+Image"
                                }
                                alt={cat.name}
                                className="admin-category-image"
                            />

                            <div className="admin-category-content">

                                <h2>{cat.name}</h2>

                                <div className="admin-category-actions">

                                    <button
                                        className="admin-view-btn"
                                        onClick={() =>
                                            navigate(`/admin/manage-gallery/photos/${encodeURIComponent(cat.name)}`)
                                        }
                                    >
                                        View Photos
                                    </button>

                                    <button
                                        className="admin-view-btn"
                                        onClick={() =>
                                            navigate(`/admin/manage-gallery/videos/${encodeURIComponent(cat.name)}`)
                                        }
                                    >
                                        View Videos
                                    </button>
                                        <button
        className="admin-edit-btn"
        onClick={() =>
            navigate(`/admin/edit-gallery-category/${cat.id}`)
        }
    >
        Edit
    </button>
                                    <button
    className="admin-delete-btn"
    onClick={() =>
        setDeletePopup({
            show: true,
            id: cat.id
        })
    }
>
    Delete
</button>

                                </div>

                            </div>

                        </div>

                    ))}

                </div>




            )}
             

        </div>
        
     
    </div>
    </div>

    <Footer />
    </>
);

}

export default AdminGalleryCategories;